import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ArrowIosDownward } from '@lyearn/icons';
import AsyncSelect from '@/components/AsyncSelect';
import { renderUserOption, renderUserTag } from '@/components/AsyncSelect/entity/user/renderers';
import useUsers from '@/components/UsersSearch/hooks/useUsers';

import { asyncSelectClasses } from './styles';
import { PraiseRecipientsProps } from './types';
import { renderInput } from './utils';

const QUERY_PARAMS = { excludeSelf: true };

const PraiseRecipients: React.FC<PraiseRecipientsProps> = (props) => {
  const { value, onChange, error, setFieldValue } = props;
  const { t } = useTranslation();

  const onChangeRecipients = useCallback(
    (recipients: any) => {
      onChange(recipients);
      setFieldValue('skillRatings', [], true);
    },
    [onChange, setFieldValue],
  );

  return (
    <AsyncSelect
      disableClearable
      multiple
      classes={asyncSelectClasses}
      error={error}
      optionLabelRenderer={renderUserOption}
      placeholder={value.length ? '' : t('Praises:Form.AddPeople')}
      popupIcon={<ArrowIosDownward className="h-20 w-20" fillColorToken="icon-placeholder" />}
      queryParams={QUERY_PARAMS}
      renderInput={(params) => renderInput(value, params)}
      tagLabelRenderer={renderUserTag}
      useOptionsQuery={useUsers}
      value={value}
      onChange={onChangeRecipients}
    />
  );
};

export default PraiseRecipients;
